<template>
    <div>
        <h4 class="pt-3 text-center">Covered Members</h4>
        <hr class="smaller-hr">
        <div v-if="showCardView">
            <div class="container memberCard" :class="paidCardClass(familyMember)"  v-for="familyMember in membersData || []" :key="familyMember.id" @click.right.prevent @keydown="keydown" @copy.prevent @paste.prevent>
                <div class="row">
                    <div class="col" :class="paidTextClass(familyMember)">{{familyMember.firstName + " " + familyMember.lastName }} </div>
                    <div class="col"> <div class="row d-flex float-end me-1" :class="paidTextClass(familyMember)">{{familyMember.relationToHead.name}}</div></div>
                </div>
                <div class="row">
                    <div class="col" :class="paidTextClass(familyMember)">{{ familyMember.rate.amount != null ? displayInUSD(familyMember.rate.amount) : familyMember.rate.info}}</div>
                    <div class="col">
                        <div class="d-flex float-end justify-content-end">
                            <div v-if="familyMember.status.id !== 1">
                                <i class="material-icons green">attach_money</i>
                            </div>
                            <div v-else-if="familyMember.rate.amount === null" />
                            <div v-else class="form-check form-switch d-flex align-items-start">
                                <input class="form-check-input " type="checkbox" v-model="familyMember.includeInPlan">
                            </div>
                            <h6 class="mx-2" v-if="familyMember.rate.amount !== null"> Include </h6>  
                        </div>
                    </div>
                </div>
            </div>
            <div class="summary-card">
                <h5 class="summary-title">Payment Summary</h5>
                <div class="summary-row summary-subtotal">
                    <div><b>Subtotal</b></div>
                    <div><b>{{displayInUSD(subtotalAmount)}}</b></div>
                </div>
                <DonationPanel
                    :donationInputField="donationInputField"
                    :setDonationAmount="setDonationAmount"
                    :stacked="true"
                />
                <div class="summary-row summary-total">
                    <div><b>Total</b></div>
                    <div><b>{{displayInUSD(totalAmount)}}</b></div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="table-responsive household-Member-Table pt-2">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Relationship</th>
                            <th>Included</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr :class="paidRowClass(familyMember)" v-for="familyMember in membersData || []" :key="familyMember.id"  @click.right.prevent @keydown="keydown" @copy.prevent @paste.prevent>
                            <td :class="paidTextClass(familyMember)"> {{ familyMember.firstName }} {{ familyMember.lastName }}</td>
                            <td :class="paidTextClass(familyMember)"> {{ familyMember.relationToHead.name}}</td>
                            <td class="text-center">
                                <div v-if="familyMember.status.id !== 1">
                                    <i class="material-icons green">attach_money</i>
                                </div>
                                <div v-else-if="familyMember.rate.amount === null" />
                                <div v-else class="form-check form-switch form-control-lg">
                                    <input class="form-check-input " type="checkbox" v-model="familyMember.includeInPlan">
                                </div>
                            </td>
                            <td :class="paidTextClass(familyMember)">{{ familyMember.rate.amount != null ? displayInUSD(familyMember.rate.amount): familyMember.rate.info }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr class="noBorder">
                            <td></td>
                            <td></td>
                            <td style="text-align:right"><b>Subtotal:</b></td>
                            <td>{{displayInUSD(subtotalAmount)}}</td>
                        </tr>
                    <tr class="noBorder">
                        <td colspan="4">
                            <div class="donation-row">
                                <DonationPanel
                                    :donationInputField="donationInputField"
                                    :setDonationAmount="setDonationAmount"
                                    :stacked="false"
                                />
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td colspan="2" style="text-align:right"><b>Total:</b></td>
                        <td><b>{{displayInUSD(totalAmount)}}</b></td>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import { ref } from 'vue'
import DonationPanel from '../components/DonationPanel.vue';
import { displayInUSD } from '../utils/MethodUtils.js'
export default {
    props: [
        "membersData",
        "subtotalAmount", 
        "totalAmount", 
        "donationInputField",
        "setDonationAmount"
    ],
    name: "PaymentTable",
    components: {
        DonationPanel
    },
    setup() {
        const showCardView=ref(false);
        return {
            showCardView,
            displayInUSD
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    unmounted() {
        window.removeEventListener('resize', this.handleResize);
    },
    data: () => ({
        window:{
            width: 0
        }
    }),
    methods:{
        handleResize() {
            this.window.width = window.innerWidth;
            if (this.window.width < 500) {
                this.showCardView=true
            } else {
                this.showCardView=false
            }
        },
        paidRowClass: (familyMember) => {
            if (familyMember.status.id !== 1) {
                return { 'table-success': true}
            } else if (familyMember.rate.amount === null) {
                return { 'table-danger': true}
            } else {
                return { 'table-secondary': !familyMember.includeInPlan }
            }
        },
        paidCardClass: (familyMember) => {
            if (familyMember.status.id !== 1) {
                return { 'paid-card': true}
            } else if (familyMember.rate.amount === null) {
                return { 'invalid-card': true }
            }else {
                return { 'unincluded-card': !familyMember.includeInPlan }
            }
        },
        paidTextClass: (familyMember) => {
            if (familyMember.status.id === 1 && familyMember.rate.amount !== null) {
                return { 'excluded': !familyMember.includeInPlan }
            }
        }
    }
}
</script>
<style scoped>
    .paid-card {
        background-color: #d1e7dd;
    }
    .invalid-card{
        background-color: #f8d7da;
    }
    .unincluded-card {
        background-color: #e2e3e5;
    }
    .form-check-input:checked {
        background-color: green;
    }
    .include-input {
        border: 1px red solid;
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
    }
    .memberCard{
        border-bottom: 1px solid #ccc;
        padding: 4px;
    }
    .material-icons.green { 
        color: green; 
    }
    .smaller-hr{
        margin: 0.15rem auto;
    }
    tr.noBorder td {
        border-style:hidden;
    }
    .excluded {
        text-decoration:line-through;
    }
    .testing-this {
        border: 1px blue solid;
        height: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
    }
    /* Desktop: the donation panel lines up with the right edge of the table */
    .donation-row {
        max-width: 760px;
        margin-left: auto;
        padding: 4px 0;
    }
    /* Mobile: subtotal, donation and total grouped in one card */
    .summary-card {
        border: 1px solid #dee2e6;
        border-radius: 10px;
        padding: 16px;
        margin: 16px 0;
        background-color: #ffffff;
    }
    .summary-title {
        font-weight: 600;
        margin-bottom: 12px;
    }
    .summary-card .summary-row {
        padding: 10px 0;
    }
    .summary-card .summary-subtotal {
        border-bottom: 1px solid #dee2e6;
        margin-bottom: 12px;
    }
    .summary-card .summary-total {
        border-top: 1px solid #dee2e6;
        margin-top: 12px;
        padding-bottom: 0;
        font-size: 1.15rem;
    }
    .footer-inputs {
        max-width: 350px;
    }
    .summary-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding-bottom: 12px;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    input[type=number]{
        -moz-appearance: textfield;
    }       
</style>
